import React, { Component } from 'react';
import { connect } from 'react-redux';
import MenuItem from 'material-ui/MenuItem';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import ActionLanguage from 'material-ui/svg-icons/action/language';
import SocialPersonOutline from 'material-ui/svg-icons/social/person-outline'
import ActionHelpOutline from 'material-ui/svg-icons/action/help-outline'
import NavigationMenu from 'material-ui/svg-icons/navigation/menu'
import FlatButton from 'material-ui/FlatButton';
import locale from '../../common/locale'
import { setLocale } from '../../actions';
import { Link } from "react-router-dom";
import NotificationsIconMenu from './NotificationsIconMenu';
import { callWidget } from '../../actions';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export class MenuBar extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const loc = cookies.get('locale')

    return (
      <div>
        <MuiThemeProvider>
          <AppBar
            style={{
              backgroundColor: '#F5F5F5',
              position: 'fixed',
              height: 30, opacity: 0.8,
            }}
            titleStyle={{height: 30}}
            iconElementLeft={
              <div>
                <IconMenu
                  iconButtonElement={
                    <IconButton style={{position: 'fixed', top: '5px', height: '30px', padding: 0}}>
                      <NavigationMenu color="#606060" style={{}}/>
                    </IconButton>
                  }>
                  <MenuItem primaryText={locale.top_node(loc)}
                    containerElement={<a href="/"> </a>}
                  />
                  { (window.location.pathname === '/' || window.location.pathname.indexOf('/node') === 0 
                  && this.props.client.x['r'] !== 300)
                      ? (
                        <MenuItem primaryText={locale.user_ranking(loc)}
                          onMouseDown={e => this.props.callWidget(e, 'r') }
                        />
                      )
                      : (
                        <MenuItem primaryText={locale.user_ranking(loc)} disabled={true}
                        />
                      )
                  }
                  <MenuItem primaryText={locale.about_this_site(loc)}
                    containerElement={<Link to="/about" />}
                  />
                </IconMenu>
                <a href="/"><h4 className='logo'><i className="fas fa-share-alt fa-lg" /> node-node-node</h4></a>
              </div>
            }>
            <IconButton style={{top: '5px', height: '30px', padding: 0}}
              containerElement={<Link to="/help" />}  >
              <ActionHelpOutline color="#606060" style={{}}/>
            </IconButton>
            <h4 className="help">{locale.help(loc)}</h4>
            { (cookies.get('api_access_token') === 'undefined' || cookies.get('api_access_token') == null)
                ? (
                  <div>
                    <IconMenu
                      iconButtonElement={
                        <IconButton style={{height: '30px', padding: 0}}>
                          <SocialPersonOutline color="#606060" style={{}}/>
                        </IconButton>
                      }
                      onChange={this.handleChangeLocale}
                      value={this.state.valueSingle}>
                      <MenuItem primaryText={locale.sign_up(loc)}
                        containerElement={<Link to="/signup" />}
                      />
                      <MenuItem primaryText={locale.login(loc)}
                        containerElement={<Link to="/login" />}
                      />
                    </IconMenu>
                  </div>
                )
                : (
                  <div>
                    <IconMenu
                      iconButtonElement={
                        <FlatButton label={cookies.get('name')}
                          style={{height: 30}}
                          labelStyle={{textTransform: 'none'}}
                        />
                      }
                      value={this.state.valueSingle}>
                      <MenuItem value="en" primaryText={locale.myPage(loc)}
                        containerElement={<Link to="/my_page" />}
                      />
                      <MenuItem value="ja" primaryText={locale.logout(loc)}
                        containerElement={<Link to="/logout" />}
                      />
                    </IconMenu>
                  </div>
                )
            }

            <IconMenu
              iconButtonElement={
                <div>
                  <IconButton style={{height: '30px', padding: 0}}>
                    <ActionLanguage color="#606060" style={{}}/>
                  </IconButton>
                  <h4 className="locale">{this.props.client.locale}</h4>
                </div>
              }
              onChange={this.handleChangeLocale} >
              <MenuItem value="ja" primaryText="日本語" />
              <MenuItem value="en" primaryText="English" />
            </IconMenu>
            <NotificationsIconMenu />

          </AppBar>
        </MuiThemeProvider>
      </div>
    )
  }

  handleChangeLocale = (event, value) => {
    cookies.set('locale', value, { path: '/' })
    this.props.setLocale(value)
    if(window.location.pathname === '/' || !window.location.pathname.indexOf('/nodes/') ) {
      window.location.href = "/"
    }
  }
}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

const mapDispatchToProps = {
  setLocale,
  callWidget
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuBar)



// WEBPACK FOOTER //
// ./src/components/fixedComponents/MenuBar.js